import i18n from "i18next"
import {initReactI18next, useTranslation} from "react-i18next"
import Backend from "i18next-http-backend"
import detector from "i18next-browser-languagedetector"
import type {I18nProvider} from "@refinedev/core"

import enEN from "antd/locale/en_US"
import frFR from "antd/locale/fr_FR"
import "dayjs/locale/en"
import "dayjs/locale/fr"

i18n.use(Backend)
    .use(detector)
    .use(initReactI18next)
    .init({
        supportedLngs: ['fr', 'en'],
        backend: {loadPath: '/locales/{{lng}}.json'},
        fallbackLng: ['fr', 'en'],
    });

export const i18nProvider = (): I18nProvider => {
    const {t, i18n} = useTranslation()
    return {
        // @ts-ignore
        translate: (key: string, defaultMessage?: string) => t(key, defaultMessage),
        changeLocale: (lang: string) => i18n.changeLanguage(lang),
        getLocale: () => i18n.language,
    }
}

export const antdLocales: any = {fr: frFR, en: enEN}
export const dayjsLocales: any = {fr: 'fr', en: 'en'}